import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { withStyles, MenuItem } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import red from '@material-ui/core/colors/red';
import {
  TextField,
  PasswordField,
  Button,
  LoadingIndicator,
  GenderSelect,
  AppBar,
  DatePicker,
  Checkbox,
  Subheader,
  NavigationLink,
} from '../../components';
import { ThemeImages, ThemeColors } from '../../theme';
import Immutable from 'seamless-immutable';

import ENV from '../../../run-config';
import { getTheme2 } from '../../app.theme';
import theme from '../../app.theme';
import LoginSignupWrapper from '../loginSignupWrapper';
import CheckboxIcon from '@material-ui/icons/CheckBox';
import ClearIcon from '@material-ui/icons/Clear';

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      totalSteps: 3,
      industrySector: 'selectIndustrySector',
      employeeCount: 'selectEmployeeCount',
      domain: 'www.',
      country: 'chooseCountry',
    };

    this.industrySectorList = [
      { value: 'Bank und Versicherung', title: 'Bank und Versicherung' },
      { value: 'Gewerbe und Handwerk', title: 'Gewerbe und Handwerk' },
      { value: 'Handel', title: 'Handel' },
      { value: 'Industrie', title: 'Industrie' },
      { value: 'Information und Consulting', title: 'Information und Consulting' },
      { value: 'Tourismus und Freizeitwirtschaft', title: 'Tourismus und Freizeitwirtschaft' },
      { value: 'Transport und Verkehr', title: 'Transport und Verkehr' },
      { value: 'Sonstiges', title: 'Sonstiges' },
    ];

    this.employeeCount = [
      { value: '0 - 9', title: '0 - 9' },
      { value: '10 - 49', title: '10 - 49' },
      { value: '50 - 249', title: '50 - 249' },
      { value: 'ab 250', title: 'ab 250' },
    ];

    this.countryList = [
      { value: 'AT', title: 'Österreich' },
      { value: 'DE', title: 'Deutschland' },
      { value: 'CH', title: 'Schweiz' },
    ];
  }

  /*
        public string Name { get; set; }
        public string FirebaseTopic { get; set; }
        public string Domain { get; set; }
        public string Street { get; set; }
        public string City { get; set; }
        public string Zip { get; set; }
        public string Country { get; set; }
        public string Phone { get; set; }
        public string Email { get; set; }
        public string IndustrySector { get; set; }
        public int EmployeeCount { get; set; }
        */


  onChangeTextField = (key, value) => {
    this.setState({
      [key]: value,
    });
  }

  handleChangeSelect = (key, value) => {
    this.setState({
      [key]: value,
    });
  }

  handleIncreaseStepper = () => {
    this.setState({
      currentStep: this.state.currentStep + 1,
    });
  }

  handleDecreaseStepper = () => {
    this.setState({
      currentStep: this.state.currentStep - 1,
    });
  }

  handleSignup = () => {
    const userRegistration = {
      company: this.state.name,
      confirmPassword: this.state.passwordRepeat,
      email: this.state.email,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      password: this.state.password,
    };

    const organizationInfo = {
      name: this.state.name,
      domain: this.state.domain,
      street: this.state.street,
      city: this.state.city,
      zip: this.state.zip,
      country: this.state.country,
      phone: this.state.phone,
      email: this.state.email,
      industrySector: this.state.industrySector,
      employeeCount: this.state.employeeCount,
    };

    const registrationDto = { userRegistration, organizationInfo };

    this.handleIncreaseStepper();

    this.props.platformSignup(registrationDto);
  }

  checkCanIncreaseStep() {
    switch (this.state.currentStep) {
      case 1:
        return this.state.name && this.state.domain &&
          this.state.phone && this.state.organizationEmail &&
          (this.state.industrySector && this.state.industrySector !== 'selectIndustrySector') &&
          (this.state.employeeCount && this.state.employeeCount !== 'selectEmployeeCount' &&
          this.props.organizationNameAvailable);
      case 2:
        return this.state.street && this.state.zip &&
          this.state.city &&
          (this.state.country && this.state.country !== 'chooseCountry');

      case 3:
        return this.state.firstName && this.state.lastName &&
          this.state.email &&
          (this.state.password && this.state.password.length >= 6 && this.state.password === this.state.passwordRepeat);
      default: return false;
    }
  }

  checkOrganizationAvailable = () => {
    if (!this.state.name) return;
    this.props.checkOrganizationAvailable(this.state.name);
  }

  renderOrganizationNameNotAvailable() {
    if (this.props.organizationNameAvailable) return null;
    const { classes } = this.props;

    return (
      <Typography className={classes.companyNameNotAvailable}>
        Unternehmensname ist bereits vergeben.
      </Typography>
    );
  }

  renderTextField(key, placeholder, focus, required, type, onBlur) {
    return (
      <TextField
        autoFocus={focus}
        type={type}
        label={placeholder}
        formControlStyle={{ marginTop: 20 }}
        style={{ marginTop: 10 }}
        onBlur={onBlur}
        required={required}
        value={this.state[key]}
        onChange={e => this.onChangeTextField(key, e.target.value)}
      />
    );
  }

  renderPasswordField(key, placeholder) {
    return (
      <FormControl style={{ width: '100%', marginTop: 20 }}>
        <InputLabel shrink id="input-label-password" required>
          {placeholder}
        </InputLabel>
        <PasswordField
          required
          hintText={placeholder}
          value={this.state[key]}
          onChange={e => this.setState({ [key]: e.target.value })}
        />
      </FormControl>
    );
  }


  renderDropDown(key, list, noSelectionItem, label) {
    return (
      <FormControl style={{ width: '100%', marginTop: 20 }}>
        <InputLabel shrink id="demo-simple-select-placeholder-label-label" required>
          {label}
        </InputLabel>
        <Select
          value={this.state[key]}
          style={{ width: '100%', paddingTop: 10 }}
          onChange={e => this.handleChangeSelect(key, e.target.value)}
        >
          {/* <MenuItem disabled value={noSelectionItem.value}>
            <em style={{ color: 'lightgrey' }}>{noSelectionItem.title}</em>
          </MenuItem> */}
          {list.map(item => <MenuItem value={item.value}>{item.title}</MenuItem>)}
        </Select>
      </FormControl>
    );
  }

  renderImpressLink() {
    if (ENV.impressUrl) {
      return (
        <a target="_blank" style={{ fontSize: 11, padding: 10, textAlign: 'center' }} href={ENV.impressUrl}>Hiermit stimmst du unseren Nutzungsbedingungen und Datenschutzbestimmungen zu</a>
      );
    }

    return (
      <a style={{ fontSize: 11, padding: 10, textAlign: 'center' }} href="/impressum">Hiermit stimmst du unseren Nutzungsbedingungen und Datenschutzbestimmungen zu</a>
    );
  }

  renderNextButton() {
    if (this.state.currentStep >= this.state.totalSteps) return null;
    return (
      <Button
        label="Weiter"
        color="primary"
        variant="contained"
        disabled={!this.checkCanIncreaseStep()}
        style={{ color: 'white', marginTop: 10 }}
        onClick={this.handleIncreaseStepper}
      />
    );
  }

  renderSignUpButton() {
    if (this.state.currentStep !== 3) return null;
    return (
      <Button
        label="Registrieren"
        color="secondary"
        variant="contained"
        disabled={!this.checkCanIncreaseStep()}
        style={{ color: 'white', width: '100%', marginTop: 10 }}
        onClick={this.handleSignup}
      />
    );
  }

  renderPreviousButton() {
    if (this.state.currentStep <= 1 || this.state.currentStep > this.state.totalSteps) return <div />;
    return (
      <Button
        label="Zurück"
        color="primary"
        style={{ color: 'black', marginTop: 10 }}
        onClick={this.handleDecreaseStepper}
      />
    );
  }

  renderAdminForm() {
    if (this.state.currentStep !== 3) return null;
    return (
      <div>
        {this.renderTextField('firstName', 'Vorname', true, true, 'text')}
        {this.renderTextField('lastName', 'Nachname', false, true, 'text')}
        {this.renderTextField('email', 'Ihre E-Mail', false, true, 'email')}
        {this.renderPasswordField('password', 'Passwort')}
        {this.renderPasswordField('passwordRepeat', 'Passwort wiederholen')}
        {this.renderImpressLink()}
      </div>
    );
  }

  renderAdressForm() {
    if (this.state.currentStep !== 2) return null;
    return (
      <div>
        {this.renderTextField('street', 'Straße und Hausnummer', true, true, 'text')}
        {this.renderTextField('zip', 'PLZ', false, true, 'number')}
        {this.renderTextField('city', 'Ort', false, true, 'text')}
        {this.renderDropDown('country', this.countryList, { value: 'chooseCountry', name: 'Land' }, 'Land')}
      </div>
    );
  }


  renderOrganizationForm() {
    if (this.state.currentStep !== 1) return null;
    return (
      <div>
        {this.renderTextField('name', 'Organisationsname', true, true, 'text', this.checkOrganizationAvailable)}
        {this.renderOrganizationNameNotAvailable()}
        {this.renderTextField('domain', 'Website', false, true, 'url')}
        {this.renderTextField('phone', 'Telefonnummer', false, true, 'number')}
        {this.renderTextField('organizationEmail', 'Office-Email', false, true, 'email')}
        {this.renderDropDown('industrySector',
          this.industrySectorList,
          { value: 'selectIndustrySector', title: 'Branche wählen' },
          'Branche')}
        {this.renderDropDown('employeeCount',
          this.employeeCount,
          { value: 'selectEmployeeCount', title: 'Anzahl wählen' },
          'Anzahl Mitarbeiter')}
      </div>
    );
  }

  renderSignupCompleted() {
    if (this.state.currentStep !== this.state.totalSteps + 1) return null;
    if (this.props.loading) return <LoadingIndicator />;
    if (this.props.errorMessage) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography
            style={{
              fontSize: 18,
              fontWeight: 800,
              textAlign: 'center',
            }}
          >Leider ist ein Fehler aufgetreten</Typography>
          <Typography
            style={{
              textTransform: 'uppercase',
              fontSize: 10,
              fontWeight: 700,
              color: '#B00020',
              textAlign: 'center',
            }}
          >{this.props.errorMessage}</Typography>
          <ClearIcon
            style={{
              fontSize: 140,
              marginTop: 40,
              marginBottom: 40,
              color: '#B00020',
            }}
          />
          <Button
            label="Zurück zur Registrierung"
            color="primary"
            variant="contained"
            // disabled={!this.checkCanIncreaseStep()}
            style={{ color: 'white', marginTop: 10 }}
            onClick={() => this.setState({ currentStep: 1 })}
          />
        </div>
      );
    }

    return (

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography
          style={{
            fontSize: 18,
            fontWeight: 800,
            textAlign: 'center',
          }}
        >Registrierung erfolgreich</Typography>
        <Typography
          style={{
            textTransform: 'uppercase',
            fontSize: 10,
            fontWeight: 700,
            color: 'gray',
            textAlign: 'center',
          }}
        >Wir wünschen viel Erfolg beim Weiterbilden!</Typography>
        <CheckboxIcon
          style={{
            fontSize: 140,
            marginTop: 40,
            marginBottom: 40,
            color: '#53AF57',
          }}
        />
        <Button
          label="Einloggen und Losstarten"
          color="primary"
          variant="contained"
            // disabled={!this.checkCanIncreaseStep()}
          style={{ color: 'white', marginTop: 10 }}
          onClick={() => window.open(`${ENV.apiHost}/admin`)}
        />
      </div>
    );
  }

  renderBackToLogin() {
    return (
      <Typography
        style={{ textAlign: 'center', marginTop: 10, cursor: 'pointer' }}
        onClick={() => this.props.history.push('/login')}
      >
      Zurück zum Login
    </Typography>);
  }

  renderPageCount() {
    if (this.state.currentStep > this.state.totalSteps) return null;
    return <Typography>{`SEITE ${this.state.currentStep} VON ${this.state.totalSteps}`}</Typography>;
  }


  render() {
    const { classes } = this.props;

    return (
      <LoginSignupWrapper
        title="Registrierung"
        subtitle="bei der Smarter Lernen App"
        imageContainerStyle={{ background: 'linear-gradient(45deg, #77bf86, #56bdbd)' }}
      >
        <form className={classes.formStyle} onKeyPress={this.keyPress} noValidate>
          {this.renderPageCount()}
          {this.renderOrganizationForm()}
          {this.renderAdressForm()}
          {this.renderAdminForm()}
          {this.renderSignupCompleted()}
          <div className={classes.buttonContainer}>
            {this.renderPreviousButton()}
            {this.renderNextButton()}
          </div>
          {this.renderSignUpButton()}
          {this.renderBackToLogin()}

        </form>
      </LoginSignupWrapper>
    );
  }
}

Signup.propTypes = {
  signup: PropTypes.func.isRequired,
  organizationNameAvailable: PropTypes.bool,
};

Signup.defaultProps = {
  organizationNameAvailable: true,
};

const styles = () => ({
  formStyle: {
    padding: 20,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  companyNameNotAvailable: {
    fontStyle: 'italic',
    color: '#B00020',
  },
});


export default withStyles(styles)(Signup);



// WEBPACK FOOTER //
// ./src/app/platform-startscreen/signup/signup.js